<template>
    <div>
        <b-button
            @click="$bvModal.show(`${index}`)"
            :variant="'danger'"
        >
            {{ $t('lease.reference.table.sendReference.label') }}
        </b-button>
        <b-modal centered :id="`${index}`" size="lg" :title="$t('lease.reference.modal.title')" hide-footer>
            <div>
                <b-form-group
                    id="input-group-1"
                    :label="$t('lease.reference.modal.subTypes.name')"
                    label-for="formrow-inputState"
                >
                    <b-form-select
                        id="formrow-inputState"
                        v-model="caseModel.idsubtipo"
                        :options="subTypes"
                        value-field="key"
                        text-field="name"
                        type="text"
                    ></b-form-select>
                </b-form-group>
            </div>
            <div>
                <b-form-textarea
                    id="textarea"
                    v-model="text"
                    :placeholder="$t('lease.reference.modal.placeholder')"
                    rows="3"
                    max-rows="6"
                ></b-form-textarea>
            </div>
            <div class="mt-2 mb-3">
                <span class="hidden-file">
                    <input type="file" ref="fileInput" @change="onFileSelected($event)"
                            accept=".pdf,.jpg,.jpeg,.png"/>
                </span>
                <b-button
                    variant="danger"
                    @click="$refs.fileInput.click()">
                    <i
                        class="bx bx-upload font-size-16 align-middle"
                    />
                    Cargar referencia
                </b-button>
            </div>            
            <div class="row my-2 ml-0">
                <b-button
                    variant="danger"
                    class="mr-2 ml-0"
                    @click="createCase()"
                >
                    {{ $t('lease.reference.modal.send') }}
                </b-button>
                <b-button
                    variant="dark"
                    @click="$bvModal.hide(`${index}`)"
                >
                    {{ $t('lease.reference.modal.cancel') }}
                </b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
import subtypes from './subType';
import {requestsMethods, filesMethods, notesMethods} from "@/state/helpers";

export default {
    props: {
        index: Number,
        reference: Object
    },
    data() {
        return {
            files: null,
            VUE_APP_API_SITE: process.env.VUE_APP_API_SITE,
            text: "",
            caseModel: {
                asunto: "",
                //idcontacto: null,
                idcuenta: null,
                idproducto: 2,
                idsubtipo: 0,
                idtipo: 9,
                urlorigin: window.location.hostname,
            },
            dataToSend: { // TODO: check how improve this
                file: [],
                filesize: [],
                idobjeto: [],
                tags: [],
                tipoobjeto: [],
            },
            subTypes: subtypes
        }
    },
    beforeMount() {
        this.caseModel.asunto = `${this.$t('lease.reference.modal.description')} ${this.reference[this.$t('lease.reference.table.contractNumber.key')]}`;
        this.caseModel.idcuenta = this.$store.getters["rutEmpresa/cuentaSeleccionada"].id;
        this.caseModel.idcontacto = this.$store.getters["auth/contacto"].id;
    },
    methods: {
        ...requestsMethods,
        ...filesMethods,
        ...notesMethods,
        createCase() {
            this.createCaso(this.caseModel)
                .then(newCase => {
                    const data = {
                        idobjeto: newCase.id,
                        tipoobjeto: 'casos',
                        texto: this.text,
                    };
                    const complementRequests = [
                        this.addNote(data)
                    ];
                    if (this.files) {
                        for (let i = 0; i < this.files.length; i++) {
                            let dataToSend = {
                                file: this.files[i],
                                filesize: this.files[i].size,
                                idobjeto: newCase.id,
                                tags: this.files[i].name,
                                tipoobjeto: 'casos',
                            };
                            complementRequests.push(this.addFile({dataToSend, endpoint: "uploadfilecp"}));
                        }
                    }
                    Promise.all(complementRequests)
                        .then(() => {
                            this.text = "";
                            this.$bvModal.hide(`${this.index}`);
                            this.$bvToast.toast(this.$t('lease.reference.modal.success').toString(), {
                                title: this.$t('lease.reference.modal.successTitle').toString(),
                                variant: 'success',
                                solid: true
                            });
                        })
                        .catch(() => {
                            this.$bvToast.toast(
                                this.$t("lease.request.error.message").toString(),
                                {
                                title: this.$t("lease.request.error.nonFound").toString(),
                                variant: "danger",
                                solid: true,
                                }
                            );
                        });
                })
                .catch(() => {
                    this.$bvToast.toast(
                        this.$t("lease.request.error.message").toString(),
                        {
                        title: this.$t("lease.request.error.nonFound").toString(),
                        variant: "danger",
                        solid: true,
                        }
                    );
                });
        },
        onFileSelected(event) {
            this.files = event.target.files;
        }
    },
};
</script>
